import { Component } from '@angular/core';

@Component({
  selector: 'credit-report-layout',
  template: `<ng-content></ng-content>`
})
export class LayoutComponent {}
